import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-684af82a")
const _hoisted_1 = { class: "base-manage-container" }
const _hoisted_2 = { class: "swipe-wrap" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "bottom-menu"
}
const _hoisted_5 = { class: "number" }
const _hoisted_6 = { class: "resource-info" }
const _hoisted_7 = { class: "title lager-font" }
const _hoisted_8 = { class: "address medi-font" }
const _hoisted_9 = { class: "address litt-font" }
const _hoisted_10 = { class: "farmer-wrap" }
const _hoisted_11 = { class: "farmer-info" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "right" }
const _hoisted_14 = { class: "line1" }
const _hoisted_15 = { class: "name medi-font" }
const _hoisted_16 = { class: "line2 medi-font" }
const _hoisted_17 = { class: "address" }
const _hoisted_18 = { class: "distance medi-font" }
const _hoisted_19 = { class: "btn-box" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 编辑 ")
const _hoisted_21 = { class: "table-wrap" }
const _hoisted_22 = { class: "table-content" }
const _hoisted_23 = { class: "table medi-font" }
const _hoisted_24 = { class: "line" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", null, "种植品种", -1)
const _hoisted_26 = { class: "line" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", null, "地区", -1)
const _hoisted_28 = { class: "line" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", null, "面积", -1)
const _hoisted_30 = { class: "line" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", null, "预计产量", -1)
const _hoisted_32 = { class: "line" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", null, "上市时间", -1)
const _hoisted_34 = { class: "line" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", null, "供应周期", -1)
const _hoisted_36 = { class: "line remark" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", null, "备注", -1)
const _hoisted_38 = { class: "step-wrap" }
const _hoisted_39 = { class: "line1 medi-font" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "date medi-font" }
const _hoisted_43 = { class: "remark litt-font" }
const _hoisted_44 = { class: "content medi-font" }
const _hoisted_45 = ["src"]
const _hoisted_46 = { class: "content" }
const _hoisted_47 = ["src"]
const _hoisted_48 = { class: "line" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "round" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "round" }, null, -1)
const _hoisted_51 = { class: "land-menu" }
const _hoisted_52 = { class: "land-code litt-font" }
const _hoisted_53 = { class: "land-info" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("svg", {
  style: {"width":"7rem","height":"7rem","background":"rgba(255, 204, 0, 1)","border-radius":"0.3rem"},
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-dikuai-white-copy" })
], -1)
const _hoisted_55 = { class: "right-text" }
const _hoisted_56 = { class: "land-area medi-font" }
const _hoisted_57 = { class: "land-item land-date litt-font" }
const _hoisted_58 = { class: "land-item land-model litt-font" }
const _hoisted_59 = { class: "land-item land-time litt-font" }
const _hoisted_60 = { class: "land-item land-remark litt-font" }
const _hoisted_61 = { class: "bottom-menu medi-font" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = ["onClick"]
const _hoisted_64 = { class: "farming-add medi-font" }
const _hoisted_65 = { class: "farming-records" }
const _hoisted_66 = { class: "line1" }
const _hoisted_67 = { class: "medi-font" }
const _hoisted_68 = { class: "medi-font" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = ["onClick"]
const _hoisted_71 = { class: "line2 litt-font" }
const _hoisted_72 = { class: "line2" }
const _hoisted_73 = ["src"]
const _hoisted_74 = { class: "line4" }
const _hoisted_75 = ["src"]
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "round" }, null, -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "round" }, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_step = _resolveComponent("van-step")!
  const _component_van_steps = _resolveComponent("van-steps")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item")!
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu")!
  const _component_farming_task = _resolveComponent("farming-task")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_swipe, {
        class: "my-swipe",
        autoplay: 3000,
        onChange: _ctx.onSwipeChange,
        "indicator-color": "white"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataObj.images, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_swipe_item, { key: index }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: item.url + '?imageView2/1/w/375/h/200/rotate/0'
                }, null, 8, _hoisted_3)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["onChange"]),
      (_ctx.dataObj.images)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickImage && _ctx.onClickImage(...args))),
              class: "btn"
            }, "照片"),
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickVideo && _ctx.onClickVideo(...args))),
              class: "btn"
            }, "视频"),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.dataObj.images.length) + "/" + _toDisplayString(_ctx.dataObj.images.length), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.dataObj.sourceName), 1),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", null, _toDisplayString(_ctx.dataObj.addressInfo), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.dataObj.distance) + "km", 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, "资源编号：" + _toDisplayString(_ctx.dataObj.id), 1),
        _createElementVNode("div", null, "更新时间：" + _toDisplayString(_ctx.dataObj.updateTime), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        (_ctx.dataObj.farmerInfo && _ctx.dataObj.farmerInfo.headImg)
          ? (_openBlock(), _createBlock(_component_van_image, {
              key: 0,
              class: "left",
              radius: "10px",
              src: 
            _ctx.dataObj.farmerInfo.headImg + '?imageView2/1/w/120/h/120/rotate/0'
          
            }, null, 8, ["src"]))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: "left",
              src: _ctx.avatar
            }, null, 8, _hoisted_12)),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.dataObj.farmerInfo ? _ctx.dataObj.farmerInfo.farmerName : ""), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.dataObj.farmerInfo ? _ctx.dataObj.farmerInfo.addressInfo : ""), 1),
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.dataObj.distance) + "km", 1)
          ]),
          _createVNode(_component_van_icon, {
            onClick: _ctx.onCall,
            class: "call",
            size: "20",
            name: "phone-o"
          }, null, 8, ["onClick"])
        ])
      ])
    ]),
    _createVNode(_component_van_tabs, {
      active: _ctx.active,
      "onUpdate:active": _cache[11] || (_cache[11] = ($event: any) => (_ctx.active = $event)),
      class: "tab-wrap"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tab, {
          title: "资源数据",
          name: "0"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", {
                class: "btn-text medi-font",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toResource && _ctx.toResource(...args)))
              }, [
                _createVNode(_component_van_icon, { name: "edit" }),
                _hoisted_20
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", null, _toDisplayString(_ctx.dataObj.typeObject ? _ctx.dataObj.typeObject.name : ""), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("div", null, _toDisplayString(_ctx.dataObj.provinceStrName +
                    _ctx.dataObj.cityStrName +
                    _ctx.dataObj.areaStrName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", null, _toDisplayString(_ctx.dataObj.plantArea) + "亩", 1)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("div", null, _toDisplayString(_ctx.dataObj.yield ? _ctx.dataObj.yield : "0") + "斤", 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("div", null, _toDisplayString(_ctx.dataObj.launchDate), 1)
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("div", null, _toDisplayString(_ctx.dataObj.supplyCycle) + "天", 1)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("div", null, _toDisplayString(_ctx.dataObj.remark), 1)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, {
          title: "巡查记录",
          name: "1",
          class: "patrol-wrap"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "patrol-btn medi-font",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onAddTrail && _ctx.onAddTrail(...args)))
            }, "+添加"),
            _createElementVNode("div", _hoisted_38, [
              _createVNode(_component_van_list, {
                class: "step-container",
                onLoad: _ctx.onPatrolLoad,
                offset: 10
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_steps, {
                    direction: "vertical",
                    "active-color": "#009dd9",
                    "inactive-color": "#009dd9"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trailDataList, (item) => {
                        return (_openBlock(), _createBlock(_component_van_step, {
                          key: item.id
                        }, {
                          "active-icon": _withCtx(() => [
                            _hoisted_49
                          ]),
                          "inactive-icon": _withCtx(() => [
                            _hoisted_50
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("span", null, _toDisplayString(item.createTime.split(" ")[0]), 1),
                              _createElementVNode("span", null, _toDisplayString(item.userName), 1),
                              _createElementVNode("div", null, [
                                _createElementVNode("span", {
                                  onClick: ($event: any) => (_ctx.onDeleteTrail(item))
                                }, "删除", 8, _hoisted_40),
                                _createElementVNode("span", {
                                  onClick: ($event: any) => (_ctx.onEditTrail(item))
                                }, "编辑", 8, _hoisted_41)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_42, _toDisplayString(item.createTime.split(" ")[1]), 1),
                            _createElementVNode("div", _hoisted_43, _toDisplayString(item.content), 1),
                            _createElementVNode("div", _hoisted_44, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.images, (items, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "wrap",
                                  key: index
                                }, [
                                  _createElementVNode("img", {
                                    src: items.url + '?imageView2/1/w/120/h/120/rotate/0',
                                    alt: ""
                                  }, null, 8, _hoisted_45)
                                ]))
                              }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_46, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.videos, (items, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "wrap",
                                  key: index
                                }, [
                                  _createElementVNode("img", {
                                    src: items.coverImg,
                                    alt: ""
                                  }, null, 8, _hoisted_47),
                                  _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.getDuration(items.time + "")), 1)
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onLoad"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, {
          name: "2",
          title: "地块信息"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onAddLand && _ctx.onAddLand(...args)))
              }, "+新增地块")
            ]),
            _createVNode(_component_van_list, {
              class: "land-list",
              offset: 0,
              onLoad: _ctx.onLandLoad
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.landList, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "land-card",
                    key: item.id
                  }, [
                    _createElementVNode("div", _hoisted_52, "地块编码：#" + _toDisplayString(item.code), 1),
                    _createElementVNode("div", _hoisted_53, [
                      _hoisted_54,
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, " 地块面积：" + _toDisplayString(item.area) + "亩 ", 1),
                        _createElementVNode("div", _hoisted_57, " 种植时间：" + _toDisplayString(item.plantTime), 1),
                        _createElementVNode("div", _hoisted_58, " 种植模型：" + _toDisplayString(item.modelName), 1),
                        _createElementVNode("div", _hoisted_59, " 模型初始时间：" + _toDisplayString(item.initTime), 1),
                        _createElementVNode("div", _hoisted_60, " 备注：" + _toDisplayString(item.remark), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (_ctx.onDeleteLand(item)),
                        class: "del"
                      }, "删除", 8, _hoisted_62),
                      _createElementVNode("div", {
                        onClick: ($event: any) => (_ctx.onEditLand(item)),
                        class: "edit"
                      }, "编辑", 8, _hoisted_63)
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["onLoad"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, {
          name: "3",
          title: "农事任务"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_van_dropdown_item, {
                  modelValue: _ctx.selectedTaskLand,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedTaskLand = $event)),
                  options: _ctx.farmingLandList,
                  onChange: _ctx.onTaskLandChange
                }, null, 8, ["modelValue", "options", "onChange"]),
                _createVNode(_component_van_dropdown_item, {
                  modelValue: _ctx.selectedTaskStatus,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedTaskStatus = $event)),
                  options: _ctx.statusList,
                  onChange: _ctx.onTaskStatusChange
                }, null, 8, ["modelValue", "options", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_van_list, {
              class: "task-container",
              onLoad: _ctx.onTaskLoad,
              offset: 30
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskList, (item) => {
                  return (_openBlock(), _createBlock(_component_farming_task, {
                    key: item.id,
                    onUpdate: _ctx.onIgnore,
                    sourceId: _ctx.sourceId,
                    datas: item
                  }, null, 8, ["onUpdate", "sourceId", "datas"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["onLoad"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, {
          name: "4",
          title: "农事记录"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_van_dropdown_item, {
                  modelValue: _ctx.farmingLand,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.farmingLand = $event)),
                  options: _ctx.farmingLandList,
                  onChange: _ctx.onLandChange
                }, null, 8, ["modelValue", "options", "onChange"]),
                _createVNode(_component_van_dropdown_item, {
                  title: _ctx.selectedStartDate ? _ctx.selectedStartDate : '开始日期'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_datetime_picker, {
                      modelValue: _ctx.startValue,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.startValue = $event)),
                      type: "date",
                      title: "开始日期",
                      "show-toolbar": false,
                      onChange: _ctx.onStartChange
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }, 8, ["title"]),
                _createVNode(_component_van_dropdown_item, {
                  title: _ctx.selectedEndDate ? _ctx.selectedEndDate : '结束日期'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_datetime_picker, {
                      modelValue: _ctx.endValue,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.endValue = $event)),
                      type: "date",
                      title: "结束日期",
                      "show-toolbar": false,
                      onChange: _ctx.onEndChange
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }, 8, ["title"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("span", {
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onClickAddRecord && _ctx.onClickAddRecord(...args)))
              }, "+新增记录")
            ]),
            _createVNode(_component_van_list, {
              onLoad: _ctx.onRecordLoad,
              class: "record-list",
              offset: 10
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_steps, {
                  direction: "vertical",
                  "active-color": "#009dd9",
                  "inactive-color": "#009dd9"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.farmingRecordList, (item) => {
                      return (_openBlock(), _createBlock(_component_van_step, {
                        key: item.id
                      }, {
                        "active-icon": _withCtx(() => [
                          _hoisted_76
                        ]),
                        "inactive-icon": _withCtx(() => [
                          _hoisted_77
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("div", _hoisted_66, [
                              _createElementVNode("span", _hoisted_67, _toDisplayString(item.createTime.split(" ")[0]), 1),
                              _withDirectives(_createElementVNode("span", null, "#" + _toDisplayString(item.code) + "地块", 513), [
                                [_vShow, item.code]
                              ]),
                              _createElementVNode("div", _hoisted_68, [
                                _createElementVNode("span", {
                                  onClick: ($event: any) => (_ctx.onDelFarming(item))
                                }, "删除", 8, _hoisted_69),
                                _createElementVNode("span", {
                                  onClick: ($event: any) => (_ctx.onEditFarming(item))
                                }, "编辑", 8, _hoisted_70)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_71, _toDisplayString(item.farmingName ? item.farmingName + "," : "") + "完成" + _toDisplayString(item.area) + "亩,投入" + _toDisplayString(item.artificial) + "个人工 ", 1),
                            _createElementVNode("div", _hoisted_72, _toDisplayString(item.remark), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.videos, (videos) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "line3",
                                key: videos.id
                              }, [
                                _createElementVNode("video", {
                                  controls: "",
                                  src: videos.url
                                }, " 您的浏览器暂不支持视频播放 ", 8, _hoisted_73)
                              ]))
                            }), 128)),
                            _createElementVNode("div", _hoisted_74, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.images, (items, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "img-wrap",
                                  key: index
                                }, [
                                  _createElementVNode("img", {
                                    src: items.url
                                  }, null, 8, _hoisted_75)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onLoad"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["active"])
  ]))
}